export { default } from './CoverLetterDetailContent'
export * from './CoverLetterDetailContent'
